<template>
    <div id="cities-component" class="rel">
        <main id="mainContent" class="padFixBoth">

            <form id="formCiudades" class="animated fadeInUp formCiudades">
                <div class="row scr-gap-15-0">
                    <div class="col-12 col-md-6 col-xl-3">
                        <select v-model="city.state_id" data-select="on" class="required" data-name-input="Estado">
                            <option :value="0">Seleccione una Estado</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">
                                {{ state.estado }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6 col-xl-3">

                        <input id="ciudad-n" v-model="city.ciudad" type="text" class="al-inputs required scr-input" placeholder="Nombre de la ciudad" v-on:keyup="autocomplete"/>
                        <label for="ciudad-n" class="scr-supertext scr-extra">Nombre de la ciudad</label>

                        <ul v-if="show" id="listFilter">
                            <li v-for="cityDB in findCityArray" :key="cityDB.id">
                                <a href="javascript:void(0)" v-on:click="setCity(cityDB.ciudad)">{{ cityDB.ciudad }}</a>
                            </li>
                        </ul>

                    </div>
                    <div class="col-12 col-md-6 col-xl-3">
                        <input id="ciudad-a" v-model="city.abrv" type="text" class="al-inputs required scr-input" maxlength="3" minlength="3" placeholder="Abreviación, 3 caracteres maximo"/>
                        <label for="ciudad-a" class="scr-supertext scr-extra">Abreviación, 3 caracteres maximo</label>
                    </div>
                    <div class="col-12 col-md-6 col-xl-3">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
            <div class="view row">
                <div class="col col-xl-2">
                    <select v-model="cityByStateId" data-select="on" class="required" v-on:change="findCityByState()" data-name-input="Estado">
                        <option :value="0">Seleccione una Estado</option>
                        <option v-for="state in states" :value="state.id" :key="state.id">
                            {{ state.estado }}
                        </option>
                    </select>
                </div>
                <div class="col col-xl-6">
                    <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search" placeholder="Buscar por palabra">
                    <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                </div>
                <div class="col col-xl-2 cont_select">
                    <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                        <option :value="10">10</option>
                        <option :value="20">20</option>
                        <option :value="30">30</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </select>
                </div>
            </div>

            <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :items="pagination" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                <!-- A virtual column -->
                <template #cell(Ciudad)="data">
                    {{ data.item.ciudad }}
                </template>
                <template #cell(Abrv)="data">
                    {{ data.item.abrv }}
                </template>
                <template #cell(Acciones)="{item}">
                    <div class="dropdown">
                        <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-cogs"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="javascript:void(0)" v-on:click="modificar=true; updateReg(item)">Editar</a>
                            <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Borrar</a>
                        </div>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
            </b-table>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {citiesService} from "../../Services/Cities.service";
import {estadoService} from "../../Services/States.service";
import {statescitiesService} from "../../Services/Statescities.service";

export default {
    name: "ciudades",
    mixins: [myMixins],
    data() {
        return {
            cityByStateId: 0,
            filter: null,
            show: false,
            sortBy: 'Estado',
            sortDesc: false,
            city: {
                id: '',
                state_id: 0,
                ciudad: '',
                abrv: '',
            },
            isBusy: false,
            params: {
                where: [
                    {
                        field: 'ciudad',
                        operator: '=',
                        value: '',
                    }
                ]
            },
            fields: [
                {
                    key: 'Ciudad',
                    sortable: false
                },
                {
                    key: 'Abrv',
                    sortable: false
                },
                {
                    key: 'Acciones',
                    sortable: false
                }
            ],
            pagination: [],
            modificar: false,
            states: [],
            cities: [],
            findCityArray: [],
            loading: true,
            tituloBtn: 'Agregar',
            resp: '',
        }
    },
    methods: {
        async findCityByState() {
            this.isBusy = true;
            this.pagination = await statescitiesService.getCitiesByState(this.cityByStateId);
            this.isBusy = false;
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.city = data;
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async index() {
            this.states = await estadoService.getMany();
        },
        async guardar() {
            let respVal = this.valFormulariosV3('formCiudades');
            //console.log('guardando', this.city);
            //actualizando
            if (respVal) {
                this.disableSubmitBtn(true);
                //console.log('paso la validacion');
                if (this.modificar) {
                    //actualizando
                    //console.log('actualizacion');
                    this.modificar = false;
                    this.resp = await citiesService.updateOne(this.city.id, this.city);
                } else {
                    //console.log('insertando');
                    //insertando
                    this.resp = await citiesService.saveOne(this.city);
                }
                this.disableSubmitBtn(false);
            } else {
                //console.log('no paso la validacion');
            }
            this.setEmpty();
            this.getAlert(this.resp.process);
            await this.index();
            this.modificar = false;
        },
        async onClickDelete(id) {
            this.resp = await citiesService.deleteOne(id);
            this.getAlert(this.resp.process, 'delete');
            await this.index();
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        async autocomplete(e) {
            let response = '';
            if (this.city.ciudad.length > 2) {
                response = await citiesService.getCityByName(this.city.ciudad);
                this.findCityArray = response.data;
                //console.log(JSON.stringify(this.findCityArray));
                this.show = true;
            }
        },
        setCity(citySelected) {
            this.city.ciudad = citySelected;
            this.show = false;
        },
        setEmpty() {
            this.city = {
                id: '',
                state_id: 0,
                ciudad: '',
                abrv: '',
            }
        }
    },
    mounted() {
        this.index();
    }
}
</script>
<style scoped>
#formCiudades .al-inputs {
    margin: 0;
}

#formCiudades .formSubmit {
    margin-top: 0;
}
</style>
